import { useEffect, useState } from 'react'
import { Navbar } from '../../layout/Navbar'
import ProposalStatus from './ProposalStatus'
import { ProposalStatusStep } from '@/types/management.types'

export const ProposalStatusPageContent = () => {
  const [steps, setSteps] = useState<ProposalStatusStep[]>()

  useEffect(() => {
    setSteps([
      {
        id: 'authorization',
        title: 'Autorización',
        description: 'Hemos recibido y aprobado tu solicitud de arrendamiento.',
        status: 'completed',
      },
      {
        id: 'initial-payment',
        title: 'Pago inicial',
        description: 'Registramos el pago inicial.',
        status: 'completed',
      },
      {
        id: 'contract',
        title: 'Contrato',
        description:
          'Estamos preparando tu contrato. Pronto te contactaremos para la firma.',
        status: 'current',
      },
      {
        id: 'vehicle-management',
        title: 'Gestoría vehicular',
        description:
          'Estamos realizando el trámite de placas, tarjeta de circulación y otros documentos.',
        status: 'pending',
      },
      {
        id: 'vehicle-delivery',
        title: 'Entrega de vehículo',
        description:
          'Tu vehículo ya está listo. Nos pondremos en contacto para agendar la entrega.',
        status: 'pending',
      },
    ])
  }, [])

  return (
    <>
      {/* Mobile Layout */}
      <div className="min-h-screen flex flex-col md:hidden">
        {/* Mobile Header - Solo gradiente */}
        <div
          className="h-48 flex items-center justify-center relative"
          style={{
            background:
              'linear-gradient(180deg, #1789CF 0%, #02298A 84.79%, #021B79 100%)',
            minHeight: '192px',
          }}
        >
          {/* Logo centrado - más grande */}
          <div className="text-center z-10">
            <img
              src="/assets/olr-logo.png"
              alt="OLR Leasing"
              className="filter brightness-0 invert w-40 h-auto mx-auto"
            />
          </div>
        </div>

        {/* Mobile Form section - menos padding top */}
        <div className="flex-1 bg-white flex items-start justify-center pt-8 px-6 pb-6">
          <div className="w-full max-w-md"></div>
        </div>
      </div>

      {/* Desktop Layout */}
      <div className="hidden md:flex flex-col">
        <Navbar />

        {/* Main content with bg-flow */}
        <div
          className="flex-1 flex flex-col items-center justify-center px-4"
          style={{
            backgroundImage: 'url(/assets/bg-flow.svg)',
            backgroundSize: 'cover',
            backgroundPosition: 'center',
            backgroundRepeat: 'no-repeat',
          }}
        >
          <div className="bg-white px-8 rounded-lg max-w-2xl w-full mx-4">
            <ProposalStatus steps={steps} />
          </div>
        </div>
      </div>
    </>
  )
}
